// utils/analytics.js
export const gtag = (...args) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag(...args);
  }
};

// Meta Pixel wrapper — mirrors gtag(); no-op if the pixel hasn't loaded.
export const fbq = (...args) => {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq(...args);
  }
};

// 🎯 Meta: fire on successful registration (called beside the GA signup event).
export const trackSignupConversion = () => {
  fbq("track", "CompleteRegistration");
};

// 💳 Meta: fire on successful Stripe subscription (called beside the GA purchase event).
export const trackPurchaseConversion = (price) => {
  fbq("track", "Purchase", {
    currency: "USD",
    value: parseFloat(price) || 0,
  });
};

// 📝 Track form submissions (signup, signin, contact, demo)
export const trackFormSubmission = (formType, success = true) => {
  gtag("event", success ? "form_submit" : "form_error", {
    event_category: "form",
    event_label: formType,
    success: success,
  });
};

// 📞 Track demo interactions (e.g. initiated, completed)
export const trackDemoInteraction = (step, detail) => {
  gtag("event", "demo_interaction", {
    event_category: "demo",
    event_label: step,
    custom_parameter_1: detail || "",
  });
};

// 🛒 Track subscription purchase intent (when user clicks a plan)
export const trackPurchaseIntent = (planName, price) => {
  const numericPrice = parseFloat(price.replace("$", ""));
  gtag("event", "add_to_cart", {
    currency: "USD",
    value: numericPrice,
    items: [
      {
        item_id: planName.toLowerCase().replace(/\s+/g, "_"),
        item_name: planName,
        category: "subscription_plan",
        price: numericPrice,
        quantity: 1,
      },
    ],
  });
};

// 💳 Track successful Stripe subscription (on success_url)
export const trackSubscriptionSuccess = (sessionId, planName, price) => {
  gtag("event", "purchase", {
    transaction_id: sessionId,
    currency: "USD",
    value: price,
    items: [
      {
        item_id: planName.toLowerCase().replace(/\s+/g, "_"),
        item_name: planName,
        category: "subscription_plan",
        price: price,
        quantity: 1,
      },
    ],
  });
};

// 🚫 Track cancelled checkout (on cancel_url)
export const trackSubscriptionCancel = (planName) => {
  gtag("event", "subscription_cancelled", {
    event_category: "subscription",
    event_label: planName,
  });
};
